import { createStyles } from "antd-style";
import { ospThemes } from "@ospweb/sdk-ui";

export const useStyles = createStyles(({ css, prefixCls }) => {
  return {
    // ant-table-body
    tableCustom: css`
      background-color: ${ospThemes.colors.background_solid_tertiary};
      .${prefixCls}-spin-nested-loading {
        > div > .${prefixCls}-spin {
          background-color: ${ospThemes.colors.background_solid_tertiary};
        }
      }
      .${prefixCls}-table {
        background-color: ${ospThemes.colors.background_solid_tertiary};
        /* Header styles */
        &-thead {
          > tr {
            > th::before {
              display: none;
            }
            > th {
              font-size: 12px;
              line-height: 16px;
              color: ${ospThemes.colors.content_tertiary};
              background-color: ${ospThemes.colors.background_solid_tertiary};
              border: none;
              padding: 8px;
              &:first-child {
                padding-left: 12px;
              }
            }
          }
          &::after {
            display: none !important;
          }
        }

        &-tbody {
          > .${prefixCls}-table-row {
            background-color: ${ospThemes.colors
              .background_solid_tertiary} !important;
            .${prefixCls}-table-cell-row-hover {
              background-color: ${ospThemes.colors.background_solid_quaternary};
            }
          }
          > tr {
            &.${prefixCls}-table-placeholder {
              height: 300px !important;
              background-color: ${ospThemes.colors
                .background_solid_tertiary} !important;
            }
            &:first-child {
              > td {
                &:first-child {
                  // 左上圆角
                  border-radius: 0px 0px 0px 0px;
                }

                &:last-child {
                  // 右上圆角
                  border-radius: 0px 0px 0px 0px;
                }
              }
            }

            &:last-child {
              > td {
                &:first-child {
                  // 左下圆角
                  border-radius: 0px 0px 0px 0px;
                }
                &:last-child {
                  // 右下圆角
                  border-radius: 0px 0px 0px 0px;
                }
              }
            }
            
            > td {
              padding: 8px;
              &:first-child {
                background-color: ${ospThemes.colors.background_solid_tertiary};
                padding-left: 12px;
              }
            }
          }
        }
      }
    `,
  };
});
